import { urlFor } from "../../utils/imageUrl";
import { useHomeData } from "../../context/HomeContext";

import "./index.css";

export const Posts = () => {
  const homeData = useHomeData();
  const data = homeData?.posts || [];

  return (
    <>
      <section className="posts">
        {data &&
          data.map((post) => {
            return (
              <article key={post._key}>
                <img
                  src={urlFor(post.media.asset._ref).width(800).url()}
                  alt={post.heading}
                  loading="lazy"
                />
                <div className="content">
                  <a href={`/post${post.cta.slug.current}`}>
                    <h1>{post.heading}</h1>
                  </a>
                  <h3>{post.subTitle}</h3>
                  <p>
                    {post.description.split(" ").length > 65
                      ? post.description.split(" ").slice(0, 65).join(" ") +
                        "..."
                      : post.description}
                  </p>
                  <a
                    className="cta"
                    href={`${
                      post.cta.slug.current.includes("tickets")
                        ? `/${post.cta.slug.current}`
                        : `/post/${post.cta.slug.current}`
                    }`}
                  >
                    {post.cta.text}
                  </a>
                </div>
              </article>
            );
          })}
      </section>
    </>
  );
};
